import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom";
import { setIntendedPath } from "../../redux-stores/slices/layoutSlice";
import React from "react";
import withModal from "../../utils/hoc/withModal";
import { INIT_IG_AUTH_ROUTE } from "../../constants/constants";
import withSlideUpModal from "../../utils/hoc/withSlideUpModalComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../redux-stores/store";

interface InsufficientPermissionsCTAModalProps {
    feature: string,
    missing_permissions: {
        [key: string]: string,
    },
    intended_url?: string,
    onClose: () => void;
    page?: string;
}
const InsufficientPermissionsCTAModal: React.FC<InsufficientPermissionsCTAModalProps>
    = ({ missing_permissions, feature, intended_url, onClose, page }) => {

        const permissions = useSelector((state: RootState) => state.influencer.social_accounts?.find((a) => a.social_account.platform === 'ig')?.permissions);

        const dispatch = useDispatch();
        const location = useLocation();
        const navigate = useNavigate();

        const getMissingPermissions = () => {
            if (missing_permissions) {
                return Object.values(missing_permissions)
            }
            return [];
        }

        const reauthorize = async () => {
            dispatch(setIntendedPath(intended_url ?? location.pathname + location.search));
            navigate(INIT_IG_AUTH_ROUTE + '?feature=' + feature);
        }

        if (!missing_permissions) return null;

        return (
            <div className="mb-4 mt-2">
                <h6 className="new-slide-up-modal-heading">
                    { ['campaign', 'collaboration'].includes(page!) ? 'This campaign requires DM Link Automation' : 'To access this feature you need to provide us few permissions' }
                </h6>

                <div className="criteria-card">
                    <span className="criteria-card-heading">
                        Permissions Required
                    </span>
                    <div className="campaign-apply-criteria-pointers mt-2">
                        {
                            getMissingPermissions().slice(0, 2).map((permission, i) => (
                                <div className="campaign-apply-criteria-pointer" key={i}>
                                    <span className="criteria not-matched text-dark"> <i className="fa fa-arrow-right me-2"></i> {permission}</span>
                                </div>
                            ))
                        }
                        {
                            (getMissingPermissions().length === 0) &&
                            <div className="campaign-apply-criteria-pointer">
                                <span className="criteria">-None-</span>
                            </div>
                        }
                    </div>
                </div>
                {/* <div className="criteria-card mt-4">
                    <span className="criteria-card-heading">These are the only permissions we have from you</span>
                    {
                        Object.values(permissions ?? {}).map((permission, i) => (
                            <div className="campaign-apply-criteria-pointer" key={i}>
                                <span>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M18.3337 9.99984C18.3337 14.6022 14.6027 18.3332 10.0003 18.3332C5.39795 18.3332 1.66699 14.6022 1.66699 9.99984C1.66699 5.39746 5.39795 1.6665 10.0003 1.6665C14.6027 1.6665 18.3337 5.39746 18.3337 9.99984ZM13.3589 7.47456C13.603 7.71864 13.603 8.11437 13.3589 8.35845L9.19227 12.5251C8.94819 12.7692 8.55246 12.7692 8.30838 12.5251L6.64172 10.8584C6.39764 10.6144 6.39764 10.2186 6.64172 9.97456C6.88579 9.73048 7.28152 9.73048 7.5256 9.97456L8.75033 11.1993L10.6127 9.33692L12.475 7.47456C12.7191 7.23048 13.1149 7.23048 13.3589 7.47456Z" fill="#2FB551" />
                                    </svg>
                                </span>
                                <span className="criteria matched">{permission}</span>
                            </div>
                        ))
                    }
                    {
                        (Object.values(permissions ?? {}).length === 0) &&
                        <div className="campaign-apply-criteria-pointer">
                            <span className="criteria">-None-</span>
                        </div>
                    }
                </div> */}
                <div className="campaign-apply-ig-connect-benefit-actions bottom-0 pb-3">
                    <button onClick={reauthorize} className="new-ui-btn">Review Instagram Permissions</button>
                </div>
            </div>
        )
    }

export default withSlideUpModal(InsufficientPermissionsCTAModal)